/* Waïloa – wishlist (enregistrée sur l'appareil du client). */
(function () {
  var KEY = 'wl_wishlist';
  function get() { try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; } }
  function set(l) { try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {} update(); }
  function update() {
    var l = get();
    document.querySelectorAll('[data-wl-wish]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-wl-wish')) > -1;
      if (b.classList.contains('is-on') !== on) b.classList.toggle('is-on', on);
      var ap = on ? 'true' : 'false'; if (b.getAttribute('aria-pressed') !== ap) b.setAttribute('aria-pressed', ap);
    });
    /* n'écrit que si la valeur change : sinon le MutationObserver ci-dessous se relance en boucle */
    document.querySelectorAll('[data-wl-wish-count]').forEach(function (c) { var n = String(l.length); if (c.textContent !== n) c.textContent = n; if (c.hidden !== !l.length) c.hidden = !l.length; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wl-wish]'); if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wl-wish'), l = get(), i = l.indexOf(h);
    if (i > -1) l.splice(i, 1); else l.unshift(h);
    set(l);
    b.classList.add('is-pop'); setTimeout(function () { b.classList.remove('is-pop'); }, 350);
  }, true);
  window.WaiWishlist = { get: get, set: set, update: update };
  /* PERF2 : mise à jour des cœurs et du compteur quand le navigateur est libre (après le premier affichage) */
  var idle = window.requestIdleCallback ? function (fn) { requestIdleCallback(fn, { timeout: 1500 }); } : function (fn) { setTimeout(fn, 200); };
  function start() {
    idle(update);
    new MutationObserver(function () { clearTimeout(window.__wlw); window.__wlw = setTimeout(function () { idle(update); }, 120); }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();